import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Modal, Typography, TextField, Stack, Select, MenuItem } from "@mui/material";

import { Button, Alert } from "../../../common/styled";
import ModalBox from "../../../../common/ModalBox";

import useLLMConfig from "../../../../../hooks/user/useLLMConfig";

const EncodingNames = ['cl100k_base', 'p50k_base', 'r50k_base'];

function TokenLimitModal({ open, handleClose, zoneUid }) {
  const { llmPromptScanners, configLLMSettingPromptScanners } = useLLMConfig();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        encoding_name: llmPromptScanners ? llmPromptScanners?.token_limit?.encoding_name : "",
        limit: llmPromptScanners ? llmPromptScanners?.token_limit?.limit : 0,
      }}
      validationSchema={Yup.object().shape({
        encoding_name: Yup.string().nullable().required("Match type is required"),
        limit: Yup.number().integer("Token limit must be an integer").min(1, 'Token limit must be at least 1').required('Token limit is required'),
      })}
      onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        try {
          values.submit = undefined;
          await configLLMSettingPromptScanners(zoneUid, "token_limit", values);
          handleClose();
          resetForm();
        } catch (error) {
          const message = error.message || "Something went wrong";
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values }) => (
        <React.Fragment>
          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
          >
            <ModalBox sx={{ width: "60vw" }} title="Edit Token Limit Scanner" handleClose={handleClose}>
              <form noValidate onSubmit={handleSubmit}>
                <Grid container p={4} spacing={3}>
                  <Grid item xs={12}>
                    {errors.submit && (
                      <Alert mt={2} mb={3} variant="outlined" severity="error">
                        {errors.submit}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Limit</Typography>
                      <TextField
                        fullWidth
                        name="limit"
                        type="number"
                        error={Boolean(touched.limit && errors.limit)}
                        helperText={touched.limit && errors.limit}
                        value={values.limit}
                        onBlur={(e) => {
                          if (e.target.value === "") setFieldValue("limit", 0);
                        }}
                        onChange={handleChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Encoding Name</Typography>
                      <Select
                        fullWidth
                        name="encoding_name"
                        value={values.encoding_name}
                        error={Boolean(touched.encoding_name && errors.encoding_name)}
                        helperText={touched.encoding_name && errors.encoding_name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      >
                        {EncodingNames.map((type) => (
                          <MenuItem value={type} key={`encoding_name_${type}`}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} textAlign={"right"} pt={4}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                      <Button variant="outlined" color="secondary" size="modal" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained" color="success" size="modal" disabled={isSubmitting}>
                        Save
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </form>
            </ModalBox>
          </Modal>
        </React.Fragment>
      )}
    </Formik>
  );
}

export default TokenLimitModal;
